export default __webpack_public_path__ + "static/media/logo_main_dark.d8658db7.png";